import { Reducer } from 'redux';
import { Backend } from '../../Backend/Backend';
import { Logger } from '../../Utils/Logger';
import { TypedStorage } from '../../Utils/TypedStorage';
import { UserRights, UserRightsResources } from '../UserManagement/Types';
import { IUserActionTypes, IUserInfo, IUserState } from './Types';

export const initialUserInfo: IUserInfo = {
	email: '',
	firstname: '',
	id: 0,
	name: '',
	position: null,
};

export const initialResource: UserRightsResources = {
	children: [],
	id: -1,
	isparent: false,
	name: '',
};

export const initialUserManagementRights: UserRights = {
	id: -1,
	resource: initialResource,
	rights: [],
	origin: '',
};

export const initialUserState: IUserState = {
	expires: new Date(0),
	groupID: 0,
	token: '',
	username: '',
	userInfo: initialUserInfo,
	userManagementRights: initialUserManagementRights,
};

const initialUser = TypedStorage.get('userName', '');
const initialUserDate = TypedStorage.get('userDate', 0);
const initialGroupID = TypedStorage.get('groupID', 0);
const initialUserToken = TypedStorage.get('userToken', '');
const initialUserInfoTS = TypedStorage.get('userInfo', initialUserInfo);
const initialUserManagementRightsTS = TypedStorage.get(
	'userManagementRights',
	initialUserManagementRights
);

let initialState = { ...initialUserState };

if (
	initialUserToken !== '' &&
	initialUser !== '' &&
	initialUserDate !== 0 &&
	initialGroupID !== 0
) {
	const tokenDate = new Date(initialUserDate);
	const currentDate = new Date(Date.now());

	if (tokenDate > currentDate) {
		Logger.info('Reusing previous session');
		initialState = {
			expires: new Date(initialUserDate),
			groupID: initialGroupID,
			token: initialUserToken,
			username: initialUser,
			userInfo: initialUserInfoTS,
			userManagementRights: initialUserManagementRightsTS,
		};
		Backend.getInstance().setToken(initialUserToken);
	} else {
		Logger.info('Cancelling expired previous session');
		TypedStorage.set('groupID', 0);
		TypedStorage.set('userDate', 0);
		TypedStorage.set('userInfo', initialUserInfo);
		TypedStorage.set('userManagementRights', initialUserManagementRights);
		TypedStorage.set('userName', '');
		TypedStorage.set('userToken', '');
	}
}

const reducer: Reducer<IUserState> = (state = initialState, action) => {
	switch (action.type) {
		case IUserActionTypes.LOGOUT_SUCCESS: {
			TypedStorage.set('groupID', 0);
			TypedStorage.set('userDate', 0);
			TypedStorage.set('userInfo', initialUserInfo);
			TypedStorage.set('userName', '');
			TypedStorage.set('userToken', '');
			TypedStorage.set(
				'userManagementRights',
				initialUserManagementRights
			);
			return {
				token: '',
				username: initialUser,
				groupID: initialGroupID,
				expires: new Date(0),
				userInfo: initialUserInfo,
				userManagementRights: initialUserManagementRights,
			};
		}
		case IUserActionTypes.LOGIN_ERROR: {
			TypedStorage.set('userName', '');
			TypedStorage.set('groupID', 0);
			TypedStorage.set('userToken', '');
			TypedStorage.set('userDate', 0);
			TypedStorage.set('userInfo', initialUserInfo);
			TypedStorage.set(
				'userManagementRights',
				initialUserManagementRights
			);
			return {
				token: '',
				username: initialUser,
				groupID: initialGroupID,
				expires: new Date(0),
				userInfo: initialUserInfo,
				userManagementRights: initialUserManagementRights,
			};
		}
		case IUserActionTypes.LOGIN_SUCCESS: {
			console.log('test');
			console.log(action.payload);

			TypedStorage.set('userDate', action.payload[3] * 1000);
			TypedStorage.set('userInfo', action.payload[4]);
			TypedStorage.set('userName', action.payload[0]);
			TypedStorage.set('groupID', action.payload[1]);
			TypedStorage.set('userToken', action.payload[2]);
			TypedStorage.set('userManagementRights', action.payload[5]);

			return {
				expires: new Date(action.payload[3] * 1000),
				token: action.payload[2],
				userInfo: action.payload[4],
				username: action.payload[0],
				groupID: action.payload[1],
				userManagementRights: action.payload[5],
			};
		}
		default: {
			return state;
		}
	}
};

export { reducer as UserReducer };
